// Shared fitment colour tokens — used by JobCard (dashboard) and JobRow (jobs list).
// Bucket boundaries mirror `_send_job_digests` / `pick_strong_fits` in the backend.
export const FIT_BUCKET = (overall) =>
  overall === null || overall === undefined ? { key: "unknown", dot: "bg-slate-400", ring: "ring-slate-400/20" }
  : overall >= 0.75 ? { key: "blue",  dot: "bg-blue-500",    ring: "ring-blue-500/30" }
  : overall >= 0.5 ? { key: "green", dot: "bg-emerald-500", ring: "ring-emerald-500/30" }
  : overall >= 0.3 ? { key: "amber", dot: "bg-amber-500",   ring: "ring-amber-500/30" }
  :                  { key: "red",   dot: "bg-rose-500",    ring: "ring-rose-500/30" };

// Inline highlight colours for skill terms inside a job description.
// Deliberately soft so the paragraph stays readable at long length.
export const HIGHLIGHT_CLASS = {
  blue:  "bg-blue-500/15    text-blue-800    dark:text-blue-200    rounded px-0.5",
  green: "bg-emerald-500/15 text-emerald-800 dark:text-emerald-200 rounded px-0.5",
  amber: "bg-amber-500/20   text-amber-900   dark:text-amber-200   rounded px-0.5",
  red:   "bg-rose-500/15    text-rose-800    dark:text-rose-200    rounded px-0.5",
};
